export const ROUTES = {
  testData: {
    parentPath: "test-data",
    slug: "test-data",
    route: "/test-data",
  },
  patientEncounterDetails: {
    parentPath: "test-data",
    slug: "patient-encounter-details",
    route: "/test-data/patient-encounter-details",
  },
};
